var cov_hewkzt2rx = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/filter.tsx",
      hash = "03ca0ddcd8f0c584ccc04095ae3acf9b34136c92",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 204,
          column: 3
        }
      },
      "1": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 18
        }
      },
      "2": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 33,
          column: 7
        }
      },
      "3": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 54
        }
      },
      "4": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 54
        }
      },
      "5": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 60
        }
      },
      "6": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 34
        }
      },
      "7": {
        start: {
          line: 43,
          column: 34
        },
        end: {
          line: 43,
          column: 44
        }
      },
      "8": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 7
        }
      },
      "9": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 38
        }
      },
      "10": {
        start: {
          line: 50,
          column: 53
        },
        end: {
          line: 50,
          column: 63
        }
      },
      "11": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 62,
          column: 7
        }
      },
      "12": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 32
        }
      },
      "13": {
        start: {
          line: 53,
          column: 20
        },
        end: {
          line: 53,
          column: 32
        }
      },
      "14": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 60
        }
      },
      "15": {
        start: {
          line: 54,
          column: 48
        },
        end: {
          line: 54,
          column: 60
        }
      },
      "16": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 60,
          column: 9
        }
      },
      "17": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 31
        }
      },
      "18": {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 46
        }
      },
      "19": {
        start: {
          line: 57,
          column: 36
        },
        end: {
          line: 57,
          column: 46
        }
      },
      "20": {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 59,
          column: 34
        }
      },
      "21": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 20
        }
      },
      "22": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 24
        }
      },
      "23": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 19
        }
      },
      "24": {
        start: {
          line: 68,
          column: 50
        },
        end: {
          line: 68,
          column: 60
        }
      },
      "25": {
        start: {
          line: 70,
          column: 25
        },
        end: {
          line: 70,
          column: 78
        }
      },
      "26": {
        start: {
          line: 70,
          column: 56
        },
        end: {
          line: 70,
          column: 77
        }
      },
      "27": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 107
        }
      },
      "28": {
        start: {
          line: 71,
          column: 20
        },
        end: {
          line: 71,
          column: 107
        }
      },
      "29": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 76,
          column: 7
        }
      },
      "30": {
        start: {
          line: 74,
          column: 18
        },
        end: {
          line: 74,
          column: 26
        }
      },
      "31": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 49
        }
      },
      "32": {
        start: {
          line: 75,
          column: 41
        },
        end: {
          line: 75,
          column: 49
        }
      },
      "33": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 82
        }
      },
      "34": {
        start: {
          line: 78,
          column: 20
        },
        end: {
          line: 78,
          column: 82
        }
      },
      "35": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 22
        }
      },
      "36": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 36
        }
      },
      "37": {
        start: {
          line: 85,
          column: 55
        },
        end: {
          line: 85,
          column: 104
        }
      },
      "38": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 90,
          column: 7
        }
      },
      "39": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 35
        }
      },
      "40": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 89,
          column: 81
        }
      },
      "41": {
        start: {
          line: 88,
          column: 43
        },
        end: {
          line: 88,
          column: 75
        }
      },
      "42": {
        start: {
          line: 89,
          column: 13
        },
        end: {
          line: 89,
          column: 81
        }
      },
      "43": {
        start: {
          line: 89,
          column: 36
        },
        end: {
          line: 89,
          column: 81
        }
      },
      "44": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 16
        }
      },
      "45": {
        start: {
          line: 109,
          column: 50
        },
        end: {
          line: 109,
          column: 60
        }
      },
      "46": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 29
        }
      },
      "47": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 118,
          column: 7
        }
      },
      "48": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 87
        }
      },
      "49": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 48
        }
      },
      "50": {
        start: {
          line: 115,
          column: 24
        },
        end: {
          line: 115,
          column: 48
        }
      },
      "51": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 42
        }
      },
      "52": {
        start: {
          line: 116,
          column: 22
        },
        end: {
          line: 116,
          column: 42
        }
      },
      "53": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 14
        }
      },
      "54": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "55": {
        start: {
          line: 121,
          column: 26
        },
        end: {
          line: 121,
          column: 49
        }
      },
      "56": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 36
        }
      },
      "57": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 27
        }
      },
      "58": {
        start: {
          line: 125,
          column: 21
        },
        end: {
          line: 125,
          column: 27
        }
      },
      "59": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 41
        }
      },
      "60": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 46
        }
      },
      "61": {
        start: {
          line: 129,
          column: 22
        },
        end: {
          line: 129,
          column: 46
        }
      },
      "62": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 135,
          column: 21
        }
      },
      "63": {
        start: {
          line: 131,
          column: 19
        },
        end: {
          line: 131,
          column: 39
        }
      },
      "64": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 134,
          column: 9
        }
      },
      "65": {
        start: {
          line: 133,
          column: 10
        },
        end: {
          line: 133,
          column: 44
        }
      },
      "66": {
        start: {
          line: 139,
          column: 27
        },
        end: {
          line: 139,
          column: 37
        }
      },
      "67": {
        start: {
          line: 140,
          column: 23
        },
        end: {
          line: 140,
          column: 82
        }
      },
      "68": {
        start: {
          line: 140,
          column: 70
        },
        end: {
          line: 140,
          column: 71
        }
      },
      "69": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 41
        }
      },
      "70": {
        start: {
          line: 145,
          column: 85
        },
        end: {
          line: 145,
          column: 95
        }
      },
      "71": {
        start: {
          line: 146,
          column: 30
        },
        end: {
          line: 146,
          column: 40
        }
      },
      "72": {
        start: {
          line: 147,
          column: 36
        },
        end: {
          line: 147,
          column: 44
        }
      },
      "73": {
        start: {
          line: 148,
          column: 49
        },
        end: {
          line: 148,
          column: 57
        }
      },
      "74": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 161,
          column: 7
        }
      },
      "75": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 150,
          column: 31
        }
      },
      "76": {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 160,
          column: 9
        }
      },
      "77": {
        start: {
          line: 155,
          column: 26
        },
        end: {
          line: 155,
          column: 52
        }
      },
      "78": {
        start: {
          line: 162,
          column: 6
        },
        end: {
          line: 166,
          column: 7
        }
      },
      "79": {
        start: {
          line: 170,
          column: 51
        },
        end: {
          line: 170,
          column: 61
        }
      },
      "80": {
        start: {
          line: 171,
          column: 41
        },
        end: {
          line: 171,
          column: 51
        }
      },
      "81": {
        start: {
          line: 172,
          column: 20
        },
        end: {
          line: 172,
          column: 24
        }
      },
      "82": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 66
        }
      },
      "83": {
        start: {
          line: 173,
          column: 23
        },
        end: {
          line: 173,
          column: 66
        }
      },
      "84": {
        start: {
          line: 173,
          column: 51
        },
        end: {
          line: 173,
          column: 65
        }
      },
      "85": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 179,
          column: 7
        }
      },
      "86": {
        start: {
          line: 175,
          column: 23
        },
        end: {
          line: 175,
          column: 65
        }
      },
      "87": {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 178,
          column: 9
        }
      },
      "88": {
        start: {
          line: 176,
          column: 32
        },
        end: {
          line: 176,
          column: 76
        }
      },
      "89": {
        start: {
          line: 177,
          column: 10
        },
        end: {
          line: 177,
          column: 44
        }
      },
      "90": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 182,
          column: 7
        }
      },
      "91": {
        start: {
          line: 186,
          column: 57
        },
        end: {
          line: 186,
          column: 67
        }
      },
      "92": {
        start: {
          line: 187,
          column: 46
        },
        end: {
          line: 187,
          column: 56
        }
      },
      "93": {
        start: {
          line: 188,
          column: 23
        },
        end: {
          line: 188,
          column: 75
        }
      },
      "94": {
        start: {
          line: 189,
          column: 28
        },
        end: {
          line: 189,
          column: 76
        }
      },
      "95": {
        start: {
          line: 190,
          column: 20
        },
        end: {
          line: 201,
          column: 7
        }
      },
      "96": {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 202,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 17
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 204,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        loc: {
          start: {
            line: 26,
            column: 60
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        loc: {
          start: {
            line: 42,
            column: 71
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        loc: {
          start: {
            line: 49,
            column: 84
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 23
          },
          end: {
            line: 52,
            column: 24
          }
        },
        loc: {
          start: {
            line: 52,
            column: 46
          },
          end: {
            line: 62,
            column: 7
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        loc: {
          start: {
            line: 67,
            column: 28
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 67
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 70,
            column: 46
          },
          end: {
            line: 70,
            column: 47
          }
        },
        loc: {
          start: {
            line: 70,
            column: 56
          },
          end: {
            line: 70,
            column: 77
          }
        },
        line: 70
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        loc: {
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 83
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        loc: {
          start: {
            line: 108,
            column: 46
          },
          end: {
            line: 136,
            column: 5
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 130,
            column: 30
          },
          end: {
            line: 130,
            column: 31
          }
        },
        loc: {
          start: {
            line: 130,
            column: 36
          },
          end: {
            line: 135,
            column: 7
          }
        },
        line: 130
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        },
        loc: {
          start: {
            line: 138,
            column: 31
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 138
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 140,
            column: 55
          },
          end: {
            line: 140,
            column: 56
          }
        },
        loc: {
          start: {
            line: 140,
            column: 70
          },
          end: {
            line: 140,
            column: 71
          }
        },
        line: 140
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        loc: {
          start: {
            line: 144,
            column: 21
          },
          end: {
            line: 167,
            column: 5
          }
        },
        line: 144
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 155,
            column: 10
          },
          end: {
            line: 155,
            column: 11
          }
        },
        loc: {
          start: {
            line: 155,
            column: 26
          },
          end: {
            line: 155,
            column: 52
          }
        },
        line: 155
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        loc: {
          start: {
            line: 169,
            column: 17
          },
          end: {
            line: 183,
            column: 5
          }
        },
        line: 169
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 173,
            column: 46
          },
          end: {
            line: 173,
            column: 47
          }
        },
        loc: {
          start: {
            line: 173,
            column: 51
          },
          end: {
            line: 173,
            column: 65
          }
        },
        line: 173
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 176,
            column: 27
          },
          end: {
            line: 176,
            column: 28
          }
        },
        loc: {
          start: {
            line: 176,
            column: 32
          },
          end: {
            line: 176,
            column: 76
          }
        },
        line: 176
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        loc: {
          start: {
            line: 185,
            column: 13
          },
          end: {
            line: 203,
            column: 5
          }
        },
        line: 185
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 22
          },
          end: {
            line: 45,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 33
          },
          end: {
            line: 45,
            column: 34
          }
        }, {
          start: {
            line: 45,
            column: 37
          },
          end: {
            line: 45,
            column: 38
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 50,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 50,
            column: 38
          },
          end: {
            line: 50,
            column: 48
          }
        }],
        line: 50
      },
      "3": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 32
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 32
          }
        }],
        line: 53
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 60
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 60
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 21
          }
        }, {
          start: {
            line: 54,
            column: 25
          },
          end: {
            line: 54,
            column: 46
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 46
          }
        }, {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 46
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 70,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 70,
            column: 41
          }
        }, {
          start: {
            line: 70,
            column: 46
          },
          end: {
            line: 70,
            column: 77
          }
        }],
        line: 70
      },
      "8": {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 107
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 107
          }
        }],
        line: 71
      },
      "9": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 49
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 49
          }
        }],
        line: 75
      },
      "10": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 82
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 82
          }
        }],
        line: 78
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 55
          },
          end: {
            line: 85,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 65
          },
          end: {
            line: 85,
            column: 74
          }
        }, {
          start: {
            line: 85,
            column: 77
          },
          end: {
            line: 85,
            column: 104
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }, {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 89,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 89,
            column: 81
          }
        }, {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 89,
            column: 81
          }
        }],
        line: 88
      },
      "14": {
        loc: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 29
          }
        }, {
          start: {
            line: 88,
            column: 33
          },
          end: {
            line: 88,
            column: 41
          }
        }],
        line: 88
      },
      "15": {
        loc: {
          start: {
            line: 89,
            column: 13
          },
          end: {
            line: 89,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 13
          },
          end: {
            line: 89,
            column: 81
          }
        }, {
          start: {
            line: 89,
            column: 13
          },
          end: {
            line: 89,
            column: 81
          }
        }],
        line: 89
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 31
          },
          end: {
            line: 108,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 108,
            column: 38
          },
          end: {
            line: 108,
            column: 44
          }
        }],
        line: 108
      },
      "17": {
        loc: {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        }, {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        }],
        line: 113
      },
      "18": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 48
          }
        }, {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 48
          }
        }],
        line: 115
      },
      "19": {
        loc: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 42
          }
        }, {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 42
          }
        }],
        line: 116
      },
      "20": {
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        }],
        line: 120
      },
      "21": {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 27
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 27
          }
        }],
        line: 125
      },
      "22": {
        loc: {
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 46
          }
        }, {
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 46
          }
        }],
        line: 129
      },
      "23": {
        loc: {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }, {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }],
        line: 132
      },
      "24": {
        loc: {
          start: {
            line: 140,
            column: 23
          },
          end: {
            line: 140,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 140,
            column: 55
          },
          end: {
            line: 140,
            column: 71
          }
        }, {
          start: {
            line: 140,
            column: 74
          },
          end: {
            line: 140,
            column: 82
          }
        }],
        line: 140
      },
      "25": {
        loc: {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        }, {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        }],
        line: 149
      },
      "26": {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 66
          }
        }, {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 66
          }
        }],
        line: 173
      },
      "27": {
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        }, {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        }],
        line: 174
      },
      "28": {
        loc: {
          start: {
            line: 174,
            column: 10
          },
          end: {
            line: 174,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 10
          },
          end: {
            line: 174,
            column: 19
          }
        }, {
          start: {
            line: 174,
            column: 23
          },
          end: {
            line: 174,
            column: 40
          }
        }],
        line: 174
      },
      "29": {
        loc: {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        }, {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 178,
            column: 9
          }
        }],
        line: 176
      },
      "30": {
        loc: {
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 46
          },
          end: {
            line: 188,
            column: 63
          }
        }, {
          start: {
            line: 188,
            column: 66
          },
          end: {
            line: 188,
            column: 75
          }
        }],
        line: 188
      },
      "31": {
        loc: {
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 23
          },
          end: {
            line: 188,
            column: 31
          }
        }, {
          start: {
            line: 188,
            column: 35
          },
          end: {
            line: 188,
            column: 43
          }
        }],
        line: 188
      },
      "32": {
        loc: {
          start: {
            line: 189,
            column: 28
          },
          end: {
            line: 189,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 39
          },
          end: {
            line: 189,
            column: 58
          }
        }, {
          start: {
            line: 189,
            column: 61
          },
          end: {
            line: 189,
            column: 76
          }
        }],
        line: 189
      },
      "33": {
        loc: {
          start: {
            line: 197,
            column: 18
          },
          end: {
            line: 197,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 197,
            column: 29
          },
          end: {
            line: 197,
            column: 46
          }
        }, {
          start: {
            line: 197,
            column: 49
          },
          end: {
            line: 197,
            column: 58
          }
        }],
        line: 197
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/filter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getKey } from '../utils/uid';
import { getFilterTree } from '../utils/tree';
import { IS_NOT_MATCHED_VALUE } from './Result';
export default (function (Origin) {
  var _class, _temp;

  cov_hewkzt2rx.f[0]++;
  cov_hewkzt2rx.s[0]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Filter, _React$Component);

    var _super = _createSuper2(Filter);

    function Filter(props) {
      var _this;

      _classCallCheck(this, Filter);

      cov_hewkzt2rx.f[1]++;
      cov_hewkzt2rx.s[1]++;
      _this = _super.call(this, props);
      _this.resultCache = void 0;
      _this.timer = void 0;
      cov_hewkzt2rx.s[2]++;
      _this.state = {
        innerFilter: undefined,
        innerData: undefined,
        filterText: '',
        text: ''
      };
      cov_hewkzt2rx.s[3]++;
      _this.handleCreate = _this.handleCreate.bind(_assertThisInitialized(_this));
      cov_hewkzt2rx.s[4]++;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this)); // this.getResultByValues = this.getResultByValues.bind(this)

      cov_hewkzt2rx.s[5]++;
      _this.getCachedResult = _this.getCachedResult.bind(_assertThisInitialized(_this));
      cov_hewkzt2rx.s[6]++;
      _this.resultCache = new Map();
      return _this;
    }

    _createClass(Filter, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_hewkzt2rx.f[2]++;

        var _ref = (cov_hewkzt2rx.s[7]++, this.props),
            datum = _ref.datum,
            multiple = _ref.multiple;

        cov_hewkzt2rx.s[8]++;

        if (prevProps.multiple !== multiple) {
          cov_hewkzt2rx.b[0][0]++;
          cov_hewkzt2rx.s[9]++;
          datum.limit = multiple ? (cov_hewkzt2rx.b[1][0]++, 0) : (cov_hewkzt2rx.b[1][1]++, 1);
        } else {
          cov_hewkzt2rx.b[0][1]++;
        }
      }
    }, {
      key: "getTreeResult",
      value: function getTreeResult(value, prediction) {
        cov_hewkzt2rx.f[3]++;

        var _ref2 = (cov_hewkzt2rx.s[10]++, this.props),
            treeData = _ref2.treeData,
            _ref2$childrenKey = _ref2.childrenKey,
            childrenKey = _ref2$childrenKey === void 0 ? (cov_hewkzt2rx.b[2][0]++, 'children') : _ref2$childrenKey;

        var finded;
        cov_hewkzt2rx.s[11]++;

        var treeNode = function treeNode(children) {
          cov_hewkzt2rx.f[4]++;
          cov_hewkzt2rx.s[12]++;

          if (finded) {
            cov_hewkzt2rx.b[3][0]++;
            cov_hewkzt2rx.s[13]++;
            return false;
          } else {
            cov_hewkzt2rx.b[3][1]++;
          }

          cov_hewkzt2rx.s[14]++;

          if ((cov_hewkzt2rx.b[5][0]++, !children) || (cov_hewkzt2rx.b[5][1]++, children.length === 0)) {
            cov_hewkzt2rx.b[4][0]++;
            cov_hewkzt2rx.s[15]++;
            return false;
          } else {
            cov_hewkzt2rx.b[4][1]++;
          }

          cov_hewkzt2rx.s[16]++;

          for (var i = 0; i < children.length; i++) {
            var d = (cov_hewkzt2rx.s[17]++, children[i]);
            cov_hewkzt2rx.s[18]++;

            if (prediction(value, d)) {
              cov_hewkzt2rx.b[6][0]++;
              cov_hewkzt2rx.s[19]++;
              finded = d;
            } else {
              cov_hewkzt2rx.b[6][1]++;
            } // @ts-ignore


            cov_hewkzt2rx.s[20]++;
            treeNode(d[childrenKey]);
          }

          cov_hewkzt2rx.s[21]++;
          return false;
        };

        cov_hewkzt2rx.s[22]++;
        treeNode(treeData);
        cov_hewkzt2rx.s[23]++;
        return finded;
      }
    }, {
      key: "getResult",
      value: function getResult(value) {
        cov_hewkzt2rx.f[5]++;

        var _ref3 = (cov_hewkzt2rx.s[24]++, this.props),
            data = _ref3.data,
            treeData = _ref3.treeData,
            datum = _ref3.datum,
            onCreate = _ref3.onCreate;

        var prediction = (cov_hewkzt2rx.s[25]++, (cov_hewkzt2rx.b[7][0]++, datum.prediction) || (cov_hewkzt2rx.b[7][1]++, function (v, d) {
          cov_hewkzt2rx.f[6]++;
          cov_hewkzt2rx.s[26]++;
          return v === datum.format(d);
        }));
        cov_hewkzt2rx.s[27]++;

        if (treeData) {
          cov_hewkzt2rx.b[8][0]++;
          cov_hewkzt2rx.s[28]++;
          return this.getTreeResult(value, prediction);
        } else {
          cov_hewkzt2rx.b[8][1]++;
        }

        cov_hewkzt2rx.s[29]++;

        for (var i = 0, count = data.length; i < count; i++) {
          var d = (cov_hewkzt2rx.s[30]++, data[i]);
          cov_hewkzt2rx.s[31]++;

          if (prediction(value, d)) {
            cov_hewkzt2rx.b[9][0]++;
            cov_hewkzt2rx.s[32]++;
            return d;
          } else {
            cov_hewkzt2rx.b[9][1]++;
          }
        }

        cov_hewkzt2rx.s[33]++;

        if (onCreate) {
          cov_hewkzt2rx.b[10][0]++;
          cov_hewkzt2rx.s[34]++;
          return this.handleCreate(value);
        } else {
          cov_hewkzt2rx.b[10][1]++;
        }

        cov_hewkzt2rx.s[35]++;
        return undefined;
      }
    }, {
      key: "getCachedResult",
      value: function getCachedResult(value) {
        cov_hewkzt2rx.f[7]++;

        var _ref4 = (cov_hewkzt2rx.s[36]++, this.props),
            noCache = _ref4.noCache;

        var res = (cov_hewkzt2rx.s[37]++, noCache ? (cov_hewkzt2rx.b[11][0]++, undefined) : (cov_hewkzt2rx.b[11][1]++, this.resultCache.get(value)));
        cov_hewkzt2rx.s[38]++;

        if (!res) {
          cov_hewkzt2rx.b[12][0]++;
          cov_hewkzt2rx.s[39]++;
          res = this.getResult(value);
          cov_hewkzt2rx.s[40]++;

          if ((cov_hewkzt2rx.b[14][0]++, res !== undefined) && (cov_hewkzt2rx.b[14][1]++, !noCache)) {
            cov_hewkzt2rx.b[13][0]++;
            cov_hewkzt2rx.s[41]++;
            this.resultCache.set(value, res);
          } else {
            cov_hewkzt2rx.b[13][1]++;
            cov_hewkzt2rx.s[42]++;

            if (res === undefined) {
              var _res;

              cov_hewkzt2rx.b[15][0]++;
              cov_hewkzt2rx.s[43]++;
              res = (_res = {}, _defineProperty(_res, IS_NOT_MATCHED_VALUE, true), _defineProperty(_res, "value", value), _res);
            } else {
              cov_hewkzt2rx.b[15][1]++;
            }
          }
        } else {
          cov_hewkzt2rx.b[12][1]++;
        }

        cov_hewkzt2rx.s[44]++;
        return res;
      } // getResultByValues() {
      //   const { datum } = this.props
      //   const { values = [] }: { values: Value[] } = datum
      //   const result: (Item | ResultValue<Value>)[] = []
      //   values.forEach(v => {
      //     const res = this.getCachedResult(v)
      //     if (res !== undefined) {
      //       result.push(res)
      //     }
      //   })
      //
      //   return result
      // }

    }, {
      key: "handleFilter",
      value: function handleFilter(text) {
        var _this2 = this;

        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_hewkzt2rx.b[16][0]++, 'edit');
        cov_hewkzt2rx.f[8]++;

        var _ref5 = (cov_hewkzt2rx.s[45]++, this.props),
            filterDelay = _ref5.filterDelay,
            onFilter = _ref5.onFilter,
            onCreate = _ref5.onCreate;

        cov_hewkzt2rx.s[46]++;
        this.setState({
          text: text
        }); // not filter

        cov_hewkzt2rx.s[47]++;

        if (!text) {
          cov_hewkzt2rx.b[17][0]++;
          cov_hewkzt2rx.s[48]++;
          this.setState({
            filterText: '',
            innerFilter: undefined,
            innerData: undefined
          });
          cov_hewkzt2rx.s[49]++;

          if (this.timer) {
            cov_hewkzt2rx.b[18][0]++;
            cov_hewkzt2rx.s[50]++;
            clearTimeout(this.timer);
          } else {
            cov_hewkzt2rx.b[18][1]++;
          }

          cov_hewkzt2rx.s[51]++;

          if (onFilter) {
            cov_hewkzt2rx.b[19][0]++;
            cov_hewkzt2rx.s[52]++;
            onFilter(text, from);
          } else {
            cov_hewkzt2rx.b[19][1]++;
          }

          cov_hewkzt2rx.s[53]++;
          return;
        } else {
          cov_hewkzt2rx.b[17][1]++;
        }

        cov_hewkzt2rx.s[54]++;

        if (onCreate) {
          cov_hewkzt2rx.b[20][0]++;

          var _innerData = (cov_hewkzt2rx.s[55]++, this.handleCreate(text));

          cov_hewkzt2rx.s[56]++;
          this.setState({
            innerData: _innerData
          });
        } else {
          cov_hewkzt2rx.b[20][1]++;
        }

        cov_hewkzt2rx.s[57]++;

        if (!onFilter) {
          cov_hewkzt2rx.b[21][0]++;
          cov_hewkzt2rx.s[58]++;
          return;
        } else {
          cov_hewkzt2rx.b[21][1]++;
        }

        cov_hewkzt2rx.s[59]++;
        this.setState({
          filterText: text
        });
        cov_hewkzt2rx.s[60]++;

        if (this.timer) {
          cov_hewkzt2rx.b[22][0]++;
          cov_hewkzt2rx.s[61]++;
          clearTimeout(this.timer);
        } else {
          cov_hewkzt2rx.b[22][1]++;
        }

        cov_hewkzt2rx.s[62]++;
        this.timer = setTimeout(function () {
          cov_hewkzt2rx.f[9]++;
          var fn = (cov_hewkzt2rx.s[63]++, onFilter(text, from));
          cov_hewkzt2rx.s[64]++;

          if (typeof fn === 'function') {
            cov_hewkzt2rx.b[23][0]++;
            cov_hewkzt2rx.s[65]++;

            _this2.setState({
              innerFilter: fn
            });
          } else {
            cov_hewkzt2rx.b[23][1]++;
          }
        }, filterDelay);
      }
    }, {
      key: "handleCreate",
      value: function handleCreate(text) {
        cov_hewkzt2rx.f[10]++;

        var _ref6 = (cov_hewkzt2rx.s[66]++, this.props),
            onCreate = _ref6.onCreate;

        var createFn = (cov_hewkzt2rx.s[67]++, typeof onCreate === 'boolean' ? (cov_hewkzt2rx.b[24][0]++, function (t) {
          cov_hewkzt2rx.f[11]++;
          cov_hewkzt2rx.s[68]++;
          return t;
        }) : (cov_hewkzt2rx.b[24][1]++, onCreate));
        cov_hewkzt2rx.s[69]++;
        return createFn(text);
      }
    }, {
      key: "filterTreeData",
      value: function filterTreeData() {
        cov_hewkzt2rx.f[12]++;

        var _ref7 = (cov_hewkzt2rx.s[70]++, this.props),
            treeData = _ref7.treeData,
            expanded = _ref7.expanded,
            showHitDescendants = _ref7.showHitDescendants,
            onAdvancedFilter = _ref7.onAdvancedFilter,
            other = _objectWithoutProperties(_ref7, ["treeData", "expanded", "showHitDescendants", "onAdvancedFilter"]);

        var _ref8 = (cov_hewkzt2rx.s[71]++, this.state),
            innerFilter = _ref8.innerFilter;

        var filterExpandedKeys = (cov_hewkzt2rx.s[72]++, expanded);
        var newData = (cov_hewkzt2rx.s[73]++, treeData);
        cov_hewkzt2rx.s[74]++;

        if (innerFilter) {
          cov_hewkzt2rx.b[25][0]++;
          cov_hewkzt2rx.s[75]++;
          filterExpandedKeys = [];
          cov_hewkzt2rx.s[76]++;
          newData = getFilterTree(treeData, innerFilter, filterExpandedKeys, function (node) {
            cov_hewkzt2rx.f[13]++;
            cov_hewkzt2rx.s[77]++;
            return getKey(node, other.keygen);
          }, other.childrenKey, showHitDescendants, undefined, {
            advanced: !!onAdvancedFilter
          });
        } else {
          cov_hewkzt2rx.b[25][1]++;
        }

        cov_hewkzt2rx.s[78]++;
        return {
          treeData: newData,
          expanded: filterExpandedKeys,
          rawData: treeData
        };
      }
    }, {
      key: "filterData",
      value: function filterData() {
        cov_hewkzt2rx.f[14]++;

        var _ref9 = (cov_hewkzt2rx.s[79]++, this.props),
            data = _ref9.data,
            hideCreateOption = _ref9.hideCreateOption,
            other = _objectWithoutProperties(_ref9, ["data", "hideCreateOption"]);

        var _ref10 = (cov_hewkzt2rx.s[80]++, this.state),
            innerFilter = _ref10.innerFilter,
            innerData = _ref10.innerData;

        var newData = (cov_hewkzt2rx.s[81]++, data);
        cov_hewkzt2rx.s[82]++;

        if (innerFilter) {
          cov_hewkzt2rx.b[26][0]++;
          cov_hewkzt2rx.s[83]++;
          newData = data.filter(function (d) {
            cov_hewkzt2rx.f[15]++;
            cov_hewkzt2rx.s[84]++;
            return innerFilter(d);
          });
        } else {
          cov_hewkzt2rx.b[26][1]++;
        }

        cov_hewkzt2rx.s[85]++;

        if ((cov_hewkzt2rx.b[28][0]++, innerData) && (cov_hewkzt2rx.b[28][1]++, !hideCreateOption)) {
          cov_hewkzt2rx.b[27][0]++;
          var newKey = (cov_hewkzt2rx.s[86]++, getKey(innerData, other.keygen, innerData));
          cov_hewkzt2rx.s[87]++;

          if (!newData.find(function (d) {
            cov_hewkzt2rx.f[16]++;
            cov_hewkzt2rx.s[88]++;
            return getKey(d, other.keygen, d) === newKey;
          })) {
            cov_hewkzt2rx.b[29][0]++;
            cov_hewkzt2rx.s[89]++;
            newData = [innerData].concat(_toConsumableArray(newData));
          } else {
            cov_hewkzt2rx.b[29][1]++;
          }
        } else {
          cov_hewkzt2rx.b[27][1]++;
        }

        cov_hewkzt2rx.s[90]++;
        return {
          data: newData
        };
      }
    }, {
      key: "render",
      value: function render() {
        cov_hewkzt2rx.f[17]++;

        var _ref11 = (cov_hewkzt2rx.s[91]++, this.props),
            treeData = _ref11.treeData,
            onFilter = _ref11.onFilter,
            onCreate = _ref11.onCreate,
            other = _objectWithoutProperties(_ref11, ["treeData", "onFilter", "onCreate"]);

        var _ref12 = (cov_hewkzt2rx.s[92]++, this.state),
            filterText = _ref12.filterText,
            innerData = _ref12.innerData,
            text = _ref12.text;

        var filterFn = (cov_hewkzt2rx.s[93]++, (cov_hewkzt2rx.b[31][0]++, onFilter) || (cov_hewkzt2rx.b[31][1]++, onCreate) ? (cov_hewkzt2rx.b[30][0]++, this.handleFilter) : (cov_hewkzt2rx.b[30][1]++, undefined));
        var dataGenerator = (cov_hewkzt2rx.s[94]++, treeData ? (cov_hewkzt2rx.b[32][0]++, this.filterTreeData) : (cov_hewkzt2rx.b[32][1]++, this.filterData));
        var props = (cov_hewkzt2rx.s[95]++, _objectSpread2(_objectSpread2({}, other), {}, {
          filterText: filterText,
          inputText: text,
          // result: this.getResultByValues(),
          getResultByValue: this.getCachedResult,
          inputable: !!onCreate,
          onCreate: onCreate ? (cov_hewkzt2rx.b[33][0]++, this.handleCreate) : (cov_hewkzt2rx.b[33][1]++, undefined),
          onFilter: filterFn,
          innerData: innerData
        }, dataGenerator.call(this)));
        cov_hewkzt2rx.s[96]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 202,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return Filter;
  }(React.Component), _class.defaultProps = {
    data: [],
    filterDelay: 300,
    showHitDescendants: false
  }, _temp;
});